<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" ref="formRef">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.withdrawalNo" placeholder="申请编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.shopName" placeholder="店铺名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.status" placeholder="请选择状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="1"></el-option>
          <el-option label="审核通过" value="2"></el-option>
          <el-option label="审核拒绝" value="3"></el-option>
          <el-option label="已打款" value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="ID" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="user_mobile" label="用户手机号" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="name" label="店铺名称" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="user_name" label="账户名称" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="amount" label="提现金额" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          ¥{{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="bank_num" label="银行账号" width="180" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="status_txt" label="状态" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTag(scope.row.status_txt)"
            :disable-transitions="false"
          >
            {{ scope.row.status_txt }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column sortable prop="create_time_txt" label="提现时间" width="180" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-button 
            v-if="scope.row.status_txt !== '已完成'" 
            size="mini" 
            type="success" 
            icon="el-icon-circle-check" 
            @click="finished(scope.$index, scope.row)">
            完成提现
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {doWithdrawList, finishWithdraw} from '../../api/money';
import Pagination from '../../components/Pagination';

export default {
  data() {
    return {
      loading: false, //是显示加载
      listData: [],
      formInline: {
        page: 1,
        limit: 10,
        withdrawalNo: '',
        shopName: '',
        status: '',
        org_id: this.$globalConfig.orgId,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  created() {
    this.getdata(this.formInline)
  },

  methods: {
    getStatusTag(status) {
      switch (status) {
        case '已完成':
          return 'success'
        case '处理中':
          return 'danger'
        default:
          return 'info'
      }
    },

    // 获取数据列表
    getdata(parameter) {
      this.loading = true
      doWithdrawList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== 1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },

    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    // 重置表单
    resetForm() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.formInline.withdrawalNo = ''
      this.formInline.shopName = ''
      this.formInline.status = ''
      this.getdata(this.formInline)
    },

    // 完成提现
    finished(index, row) {
      const params = {
        id: row.id,
      }
      this.$confirm('确认完成提现申请吗？', '提示', {
        type: 'warning'
      }).then(() => {
        finishWithdraw(params)
          .then(res => {
            if (res.code === 1) {
              this.$message.success('处理成功')
              this.getdata(this.formInline)
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(() => {
            this.$message.error('处理失败')
          })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/money/Withdrawal.vue